import { Component } from '@angular/core';

@Component({
  selector: 'lib-home',
  imports: [],
  template: `
    <p>
      home works!
    </p>
  `,
  styles: ``
})
export class Home {

}
